<mat-form-field appearance="outline" class="w-100 custom-mat-field">
  <mat-label>{{ label }}</mat-label>

  <mat-select
    [formControl]="control"
    multiple
    [placeholder]="placeholder">

    <!-- Search -->
    <mat-option disabled>
      <ngx-mat-select-search
        [formControl]="searchCtrl"
        placeholderLabel="Search..."
        noEntriesFoundLabel="No data found">
      </ngx-mat-select-search>
    </mat-option>

    <!-- GROUP MODE -->
    <ng-container *ngIf="group; else normalOptions">
      <mat-optgroup
        *ngFor="let groupItem of filteredOptions | async"
        [label]="groupItem[groupLabel]">

        <mat-option
          *ngFor="let child of groupItem[groupChildren]"
          [value]="child[optionValue]">
          {{ child[optionLabel] }}
        </mat-option>

      </mat-optgroup>
    </ng-container>

    <!-- NORMAL MODE -->
    <ng-template #normalOptions>
      <mat-option
        *ngFor="let option of filteredOptions | async"
        [value]="option[optionValue]">
        {{ option[optionLabel] }}
      </mat-option>
    </ng-template>

  </mat-select>

  <mat-error *ngIf="control?.invalid && control?.touched">
    {{ label }} is required
  </mat-error>
</mat-form-field>